export default __webpack_public_path__ + "static/OHIF-logo-195x40-2-a8084f58e401f8f596a6ac576aee8048.svg";